import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/common/nyoni_black.png';
import _imports_1 from '../../assets/icon/colse.svg';
const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "ico-menu"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "bar"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "bar"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "bar"
})], -1);
const _hoisted_2 = {
  class: "menu-drawer"
};
const _hoisted_3 = {
  class: "menu-drawer-header"
};
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo",
  class: "menu-drawer-logo"
}, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_collapse_item = _resolveComponent("el-collapse-item");
  const _component_el_collapse = _resolveComponent("el-collapse");
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", {
    class: _normalizeClass(["menu-drawer-switch bt-menu", {
      'color-white': $data.menuSwitch,
      'bt-menu-white': $options.routeName == 'home',
      hideBar: $data.hideMenus
    }]),
    onClick: _cache[0] || (_cache[0] = $event => $data.menuSwitch = true)
  }, [_hoisted_1, _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.header.menu")), 1)], 2), _createElementVNode("div", {
    class: _normalizeClass(["menu-drawer-overlay", {
      'menu-drawer-overlay-show': $data.menuSwitch
    }]),
    onClick: _cache[1] || (_cache[1] = $event => $data.menuSwitch = false)
  }, null, 2), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("img", {
    class: "menu-colse",
    onClick: _cache[2] || (_cache[2] = $event => $data.menuSwitch = false),
    src: _imports_1,
    alt: "关闭"
  })]), _createVNode(_component_el_collapse, {
    modelValue: $data.activeName,
    "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $data.activeName = $event),
    accordion: ""
  }, {
    default: _withCtx(() => [_createElementVNode("div", {
      class: "menu-drawer-li list-bb",
      onClick: _cache[3] || (_cache[3] = $event => $options.toRouter('home'))
    }, _toDisplayString(_ctx.$t("common.header.home")), 1), _createVNode(_component_el_collapse_item, {
      title: $data.menu.products[$data.isEnOrZh],
      name: "products"
    }, {
      default: _withCtx(() => [_createElementVNode("ul", null, [_createElementVNode("li", {
        class: "menu-drawer-li",
        onClick: _cache[4] || (_cache[4] = $event => $options.toRouter('products', 'nyoni'))
      }, _toDisplayString(_ctx.$t("common.header.products.nyoni")), 1), _createElementVNode("li", {
        class: "menu-drawer-li",
        onClick: _cache[5] || (_cache[5] = $event => $options.toRouter('products', 'feiyan'))
      }, _toDisplayString(_ctx.$t("common.header.products.feiyan")), 1)])]),
      _: 1
    }, 8, ["title"]), _createElementVNode("div", {
      class: "menu-drawer-li list-bb",
      onClick: _cache[6] || (_cache[6] = $event => $options.toRouter('contact'))
    }, _toDisplayString(_ctx.$t("common.header.contact")), 1), _createVNode(_component_el_collapse_item, {
      title: $data.menu.about[$data.isEnOrZh],
      name: "about"
    }, {
      default: _withCtx(() => [_createElementVNode("ul", null, [_createElementVNode("li", {
        class: "menu-drawer-li",
        onClick: _cache[7] || (_cache[7] = $event => $options.toRouter('nyoni'))
      }, _toDisplayString(_ctx.$t("common.header.about.nyoni")), 1), _createElementVNode("li", {
        class: "menu-drawer-li",
        onClick: _cache[8] || (_cache[8] = $event => $options.toRouter('jiuling'))
      }, _toDisplayString(_ctx.$t("common.header.about.jiuling")), 1)])]),
      _: 1
    }, 8, ["title"]), _createElementVNode("div", {
      class: "menu-drawer-li list-bb",
      onClick: _cache[9] || (_cache[9] = $event => $options.toRouter('shop'))
    }, _toDisplayString(_ctx.$t("common.header.buy")), 1), _createVNode(_component_el_collapse_item, {
      title: $data.menu.language[$data.isEnOrZh],
      name: "language"
    }, {
      default: _withCtx(() => [_createElementVNode("ul", null, [_createElementVNode("li", {
        class: "menu-drawer-li",
        onClick: _cache[10] || (_cache[10] = $event => $options.toRouter('language', 'zh'))
      }, _toDisplayString(_ctx.$t("common.header.language.zh")), 1), _createElementVNode("li", {
        class: "menu-drawer-li",
        onClick: _cache[11] || (_cache[11] = $event => $options.toRouter('language', 'en'))
      }, _toDisplayString(_ctx.$t("common.header.language.en")), 1)])]),
      _: 1
    }, 8, ["title"])]),
    _: 1
  }, 8, ["modelValue"])])]);
}